import React, { useMemo } from 'react';
import { SubscriptionStatusWrapper } from './SubscriptionStatus.style';
import { useSelector } from 'react-redux';
import { lastActiveSubscriptionSelector } from '../../redux/subscriptions/selector';
import { getPlanStatus, SubscriptionStatusType } from '../../utils/getPlanStatus';
import { IonIcon } from '@ionic/react';
import { useHistory } from 'react-router-dom';
import { PrivateRoutes } from '../../routes/navigation';
import { Typography, TypographyVariantsEnum } from '@mindly/ui-components';
import { chevronForwardOutline } from 'ionicons/icons';
import { useTranslation } from 'react-i18next';

const SubscriptionStatus = () => {
  const history = useHistory();

  const lastSubscription = useSelector(lastActiveSubscriptionSelector());
  const { t } = useTranslation('subscriptions');

  const subscriptionStatus: SubscriptionStatusType = useMemo(
    () => getPlanStatus(lastSubscription, t),
    [lastSubscription, t]
  );

  if (!lastSubscription) return null;

  return (
    <SubscriptionStatusWrapper
      className={subscriptionStatus.status}
      onClick={() => history.push(PrivateRoutes.SUBSCRIPTION_CONTROL)}
    >
      <IonIcon icon={subscriptionStatus.icon} className={'subscription-icon'} />
      <Typography variant={TypographyVariantsEnum.Text14Semi}>{subscriptionStatus.text}</Typography>
      <IonIcon icon={chevronForwardOutline} className={'chevron-forward'} />
    </SubscriptionStatusWrapper>
  );
};

export default SubscriptionStatus;
